import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { togglePlanSection } from "../../../../../actions/show_modal_Action";
import { TOAST_DISMISS, TOAST_ERROR, TOAST_LOADING, TOAST_SUCCESS, baseUrl } from "../../../../../utils";
import { useEffect, useState } from "react";
import { loadLanguage } from "@uiw/codemirror-extensions-langs";
import { createTheme } from "@uiw/codemirror-themes";
import CodeMirror from "@uiw/react-codemirror";
import { DeleteKeys, updateCutomCSS } from "../../../../../actions/appsMoreAction";
import { refreshThemes } from "../../../../../actions/firstRunAction";
import { tags as t } from "@lezer/highlight";

const CustomCss = (props) => {
    const dispatch = useDispatch();
    const { themeSetting, wallData } = props
    const { cssStatus } = props.getThemeSetting;
    const { wall } = wallData
    const css = wall.Personalization.css
    const [customCSS, setCustomCSS] = useState(props.CustomCss);

    const cssRule = props.userData?.UserRule.customCss;
    const [loading, setLoading] = useState(false);

    useEffect(() => { props.themeCustomCss(customCSS) }, [customCSS])

    const myTheme = createTheme({
        theme: "light",
        settings: {
            background: "#f8f8f8",
            caret: "none",
            gutterBackground: "#f7f7f7",
        },
        styles: [
            { tag: t.comment, color: "#b06213" },
            { tag: t.variableName, color: "#ff0000" },
            { tag: [t.string, t.special(t.brace)], color: "#b83b3b" },
            { tag: t.number, color: "#166948" },
            { tag: t.bool, color: "#92349f" },
            { tag: t.null, color: "#166948" },
            { tag: t.keyword, color: "#166948" },
            { tag: t.operator, color: "#166948" },
            { tag: t.className, color: "#ff0000" },
            { tag: t.definition(t.typeName), color: "#b83b3b" },
            { tag: t.typeName, color: "#b83b3b" },
            { tag: t.angleBracket, color: "#92349f" },
            { tag: t.tagName, color: "#4d9840" },
            { tag: t.attributeName, color: "#92349f" },
            { tag: t.color, color: "#3a2ba4" },
            { tag: t.color, color: "#3a2ba4" },
        ],
    });

    const applyCss = () => {
        TOAST_LOADING();
        setLoading(true);

        updateCutomCSS(css, cssStatus)
            .then((res) => {
                TOAST_DISMISS();
                const { data } = res;
                setLoading(false);
                if (data.status) {
                    DeleteKeys();
                    themeSetting({ cssStatus: cssStatus }, 2)
                    TOAST_SUCCESS(data.message);
                    props.activeSetting(0)
                    dispatch(refreshThemes());
                } else TOAST_ERROR(data.message);
            })
            .catch((err) => {
                TOAST_ERROR("TOAST_ERRORTOAST_ERROR");
            });
    };

    return (
        <Modal
            size="lg"
            dialogClassName=" modal-dialog-centered modal-dialog"
            show={true}
            onHide={() => props.activeSetting(0)}
        >
            <Modal.Header className="border-0 pb-0">
                <div className="modal-title modal-title h4">Custom CSS</div>
                <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={() => props.activeSetting(0)}></button>
            </Modal.Header>
            <Modal.Body className="pb-0">
                <div className="row py-5">
                    <div className="col-lg-12">

                        {cssRule ?

                            <>
                                <div className="customCSS">
                                    <CodeMirror
                                        value={css}
                                        height="350px"
                                        theme={myTheme}
                                        basicSetup={{
                                            foldGutter: false,
                                            dropCursor: false,
                                            allowMultipleSelections: false,
                                            indentOnInput: false,
                                            autocompletion: false,
                                        }}
                                        extensions={[loadLanguage("css")]}
                                        onChange={(e) => themeSetting({ css: e })}
                                    />
                                </div>

                                <div className="card-toolbar modal-footer">
                                    <Button variant="primary" type="submit" onClick={() => applyCss()} className={`${loading ? "ladda-button spinner spinner-white spinner-right disabled" : ""}`}>
                                        Apply CSS
                                    </Button>
                                </div>
                            </>

                            :

                            <div className="upgredeMain text-center">
                                <div className="Errorimage pb-3">
                                    <img
                                        src={baseUrl(`error/custom-css-error.png`)}
                                        className="img-fluid"
                                        width={500}
                                        height={300}
                                    />
                                </div>
                                <div className="permissionMsg my-4 px-4">
                                    <h4 className="ErrorMsg">Custom CSS</h4>
                                    <p className="msgSec">
                                        Use custom CSS and modify widget content according to your
                                        requirements beyond Taggbox`s default settings.
                                    </p>
                                </div>
                                <div className="buttonUpgred mb-3">
                                    <Button variant="primary"
                                        id="addonFeaturesScroll"
                                        onClick={(e) => dispatch(togglePlanSection(true))}
                                        className="commanBtn px-5"
                                        data-factors-click-bind="true"
                                    >
                                        Upgrade Now
                                    </Button>
                                </div>
                            </div>

                        }

                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default CustomCss;
